// The shield chip on a Full Stop / day-based Limited habit's card (Jade,
// 2026-10-26): a shield plus a number, the days in a row without a slip.
// Tapping it still opens "Log an attempt", same as the old round shield.
// Budget ("N times a week / month") habits keep their own "used / max" pill.
import { localDateStr } from "./dateHelpers";

const dayNum = (s) => {
  const [y, m, d] = s.split("-").map(Number);
  return Date.UTC(y, m - 1, d) / 86400000;
};

// The day the habit's clean count starts from: when they quit (Full Stop),
// else its start date, else the day it was made.
export function restrictedStartDate(h) {
  return (h && (h.quitDate || h.habitStartDate || localDateStr(h.createdAt))) || "";
}

// Days in a row up to and including `today` with no slip. 0 when slipped
// today. Counts from the day after the latest slip, or from the start date.
export function cleanDays(h, today) {
  if (!h || !today) return 0;
  let from = restrictedStartDate(h) || today;
  for (const r of h.relapseLog || []) {
    const d = r && r.date;
    if (!d || d > today) continue;
    if (d === today) return 0;
    const next = dayNum(d) + 1;
    if (next > dayNum(from)) from = new Date(next * 86400000).toISOString().slice(0, 10);
  }
  if (from > today) return 0;
  return dayNum(today) - dayNum(from) + 1;
}

// Green for every type until a slip is logged today, then yellow (Jade, 2026-10-26).
export function chipTone({ slippedToday }) {
  return slippedToday ? "slipped" : "clean";
}

export const CHIP_COLORS = {
  clean: { bg: "#E9F6EC", ink: "#2E7D40" },
  slipped: { bg: "#FEF3C7", ink: "#8A6100" },
};
